
import paymentQuery from '../../graphql/queries/payment.graphql'
import EmptyCart from './EmptyCart'
import isAuthedMediclubMember from '~/middleware/isAuthedMediclubMember'
import setPreviousRoute from '~/middleware/setPreviousRoute'
import expiringStorage from '~/utils/expiringStorage'

export default {
  components: { EmptyCart },
  layout: 'checkout',
  middleware: [
    isAuthedMediclubMember,
    setPreviousRoute,
  ],

  async asyncData ({ app, store, $config }) {
    if ($config.countryCode === 'PL') {
      await app.$graphql({
        requestPayload: {
          query: paymentQuery,
        },
        successHandler: (data) => {
          const fields = data.data.przelewy24Methods.items.map((item) => {
            return {
              id: item.name,
              labelImage: item.imgUrl,
              value: item.p24Id,
            }
          })

          store.dispatch('checkout/setPaymentMethods', fields)
        },
      })
    }
  },

  data () {
    return {
      isPending: true,
      thankYouPage: null,
    }
  },

  head () {
    return {
      bodyAttrs: {
        class: `theme--${this.$config.storeCode}`,
      },
    }
  },

  mounted () {
    // @todo redirect to last checkout page
    this.handlePageShow()
    window.addEventListener('pageshow', this.handlePageShow)

    this.$store.dispatch('checkout/setPaymentMethodId', this.$cookies.get('chosen-payment-method'))

    this.isPending = false
  },

  beforeDestroy () {
    window.removeEventListener('pageshow', this.handlePageShow)
  },

  methods: {
    handlePageShow () {
      const page = expiringStorage.get('page-success')

      expiringStorage.remove('page-success')

      if (page && page.url && this.$cart.getCurrentStep() === 3) {
        window.location.href = page.url
      }
    },

    onSetThankYouPage (url) {
      expiringStorage.set('page-success', {
        url,
        cartId: this.$cart.cartId(),
      })
    },
  },
}
